import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sliceEmail'
})
export class SliceEmailPipe implements PipeTransform {

  transform(value: string, length: number): any {
    if(value.length < length){
      return value;
    }
    value = value.substring(0,length) + '...'
    return value;
  }

}
